document.addEventListener('DOMContentLoaded', function() {
    const parentContainer = document.querySelector('[id$="__cudy-form"]');
    if (!parentContainer) {
        return;
    }
    const parentObserver = new MutationObserver((mutations, parentObserver) => {
        const formEmbed = parentContainer.querySelector('form-embed');
        if (formEmbed) {
            parentObserver.disconnect();
            setTimeout(() => {
                const shadowRoot = formEmbed.shadowRoot;
                if (shadowRoot) {
                    injectFormStyles(shadowRoot);
                }
            },500)
        }
    });

    parentObserver.observe(parentContainer, {
        childList: true,
        subtree: true,
        attributes: true
    });

    setTimeout(() => {
        parentObserver.disconnect();
    }, 20000);


    function injectFormStyles(shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
        #form-container-ref form[class^="_formFieldset"]{
            gap:24px
        }
        #form-container-ref form[class^="_formFieldset"] button[type="submit"]{
            min-width:230px;
            width:fit-content;
            margin:0 auto;
        }
        #form-container-ref form button[type="submit"]:focus-visible,#form-container-ref form button[type="submit"]:hover{
            filter:none;
        }
        #form-container-ref form button{
            position:relative;
        }
        #form-container-ref form button::after{
            content: '';
            position: absolute;
            z-index: -1;
            inset: 0;
            box-shadow:0 0 0 0 var(--button-background-color);
            transition: box-shadow 100ms ease;
        }
        #form-container-ref form button:not([disabled]):hover::after{
            box-shadow:0 0 0 1px var(--button-background-color);
        }
        section[data-testid="banner-success"]::before{
            content:"";display:block;width:54px;height:54px;
            background-image:url("https://cdn.shopify.com/s/files/1/0673/4748/0820/files/icon-success.png");
            background-repeat:no-repeat;
            background-position:center;
            background-size:100%;
            margin:0 auto 12px;
        }
        `;
        shadowRoot.appendChild(style);
    }

})